import { Button } from '@app/components/various/Button';
import { Notification } from '@app/components/various/Notification';
import { compiledPaths } from '@app/paths';
import { isDefined } from '@app/utils/is';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

export const CheckoutPaymentFailure = () => {
  const { t } = useTranslation(['checkout', 'checkoutMessages']);
  const { id } = useParams<{ id: string }>();

  return (
    <div className="mx-auto flex w-full max-w-screen-xl flex-col items-start gap-5 px-4 py-4 lg:px-8 lg:py-8">
      <h2 className="heading-2">{t('checkoutMessages:payment_failure.header')}</h2>
      <Notification type="error" message={t('checkoutMessages:payment_failure.details')} />
      {isDefined(id) && (
        <Button as={Link} to={compiledPaths.CHECKOUT_ORDER({ id })}>
          {t('checkout:back_to_checkout')}
        </Button>
      )}
    </div>
  );
};
